import React, {useMemo} from 'react';

import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import type {
  SafetyEventViewType} from 'src/app/safety-events/SafetyEventForm';
import {
  SafetyEventForm
} from 'src/app/safety-events/SafetyEventForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {SafetyEventRouteService} from 'src/shared/services/RouterService/SafetyEventRouteService';
import {SafetyEventDocumentTitle} from 'src/app/safety-events/safetyEventHelpers';

export const CreateSafetyEventPage: React.FC = () => {
  useSetDocumentTitle(SafetyEventDocumentTitle);

  const router = useMemo(
    () => new SafetyEventRouteService(false, 'create', {view: 'content'}),
    []
  );

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.SafetyEvents}>
      <SafetyEventForm
        mode="create"
        view={'content' as SafetyEventViewType}
        router={router}
      />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.SafetyEventCreate(),
  element: <CreateSafetyEventPage />,
  module: ModuleEnum.SafetyEvent,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});

